export default __webpack_public_path__ + "static/media/gallery_06.7dec40a0.jpg";